import { Component, Input, OnDestroy, OnInit } from '@angular/core'

import { Subscription } from 'rxjs'
import { MachineState } from '../../../../models/states.models'
import { TouaregControlStateParamsService } from '../../../../services/touareg-control-state-params.service'
import { TouaregControlStateLayoutComponent } from '../../layout/touareg-control-state-layout.component';

@Component({
  selector: 'app-touareg-control-state-idle',
  templateUrl: './touareg-control-state-idle.component.html',
  styleUrls: ['./touareg-control-state-idle.component.scss'],
  imports: [TouaregControlStateLayoutComponent],
})
export class TouaregControlStateIdleComponent {
  @Input()
  state!: MachineState
}
